import React from "react";

import Box from "@/ui/atoms/Box";

import type { UserDatabase } from "@/ui/organisms/userTypes";
import { DatabaseSelector } from "@proda-ai/ui-kit";
import Skeleton from "@/ui/atoms/Skeleton";

export type ViewDatabaseSelectorParams = {
    useState: () => {
        selectedDatabaseIds: number[] | null;
        userDatabases: UserDatabase[] | null;
        databasesLoadStatus: "idle" | "pending" | "resolved" | "rejected";
        initialUserDataResolved: boolean;
    };
    useCases: () => {
        onSelectedDatabases: (selectedDatabaseIds: number[]) => Promise<void>;
    };
};

export const createViewDatabaseSelector = ({
    useState,
    useCases,
}: ViewDatabaseSelectorParams) => {
    const ViewDatabaseSelector = () => {
        const {
            selectedDatabaseIds,
            databasesLoadStatus,
            userDatabases,
            initialUserDataResolved,
        } = useState();
        const { onSelectedDatabases } = useCases();

        const handleSelection = (selectedDatabaseIds: number[]) => {
            void onSelectedDatabases(selectedDatabaseIds);
        };

        const databasesNotLoadedYet =
            (databasesLoadStatus === "idle" ||
                databasesLoadStatus === "pending") &&
            !initialUserDataResolved;
        const emptyDatabaseList =
            databasesLoadStatus === "resolved" &&
            (userDatabases === null || userDatabases?.length === 0);
        const errorLoadingDatabases = databasesLoadStatus === "rejected";

        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}
            >
                <Box sx={{ zIndex: 2 }}>
                    {errorLoadingDatabases ||
                    emptyDatabaseList ? null : databasesNotLoadedYet ? (
                        <Skeleton sx={{ width: "200px", height: "32px" }} />
                    ) : (
                        <DatabaseSelector
                            key={selectedDatabaseIds?.join(",")}
                            allDbs={userDatabases ?? []}
                            initialSelectedDbIds={selectedDatabaseIds ?? []}
                            onChange={handleSelection}
                            props={{
                                MultiSelectInput: {
                                    leadingIcon: "server",
                                    style: {
                                        width: "440px",
                                        backgroundColor:
                                            "var(--proda-white-110)",
                                    },
                                },
                            }}
                        />
                    )}
                </Box>
            </Box>
        );
    };
    return ViewDatabaseSelector;
};
